import type { CSSProperties } from 'react'
import styled from 'styled-components'
import { ImageWithFallback } from 'components'

export const RELEASE_COVER_ART_MODAL_CONTAINER_STYLES: CSSProperties = {
  background: 'transparent',
  boxShadow: 'none',
  borderRadius: 0,
  width: '100vw',
  maxWidth: '100vw',
  height: '100vh',
  overflow: 'hidden'
}

export const RELEASE_COVER_ART_MODAL_BODY_STYLES: CSSProperties = {
  padding: 0
}

export const ModalBody = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  padding: 64px 32px 40px;
`

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
`

export const CoverArtImage = styled(ImageWithFallback)`
  display: block;
  width: auto;
  max-width: min(78vw, 960px);
  max-height: 82vh;
  object-fit: contain;
  border-radius: 5px;
`
